module.exports = __webpack_public_path__ + "img/2022_NM.440096d9.jpg";